<template>
  <router-view />
</template>

<script>
import { vuexTypes } from '@/vuex'
import { mapActions } from 'vuex'

export default {
  watch: {
    async $route (to, from) {
      await this.loadMyRoleInfo()
    },
  },
  methods: {
    ...mapActions({
      loadMyRoleInfo: vuexTypes.LOAD_MY_ROLE_INFO,
    }),
  },
}
</script>
